<div class="{{localService.selectedLanguageCode}}"  *ngIf="localService.languageContent != null && localService.languageContent.settings != undefined">
  <div>
    <label>{{localService.languageContent.settings.hdr_prepare_data}}</label>
  </div>
  <div class="banner">
    <div class="row">
      <div class="col-sm-4">
        <button type="button" class="btn btn-secondary" (click)="onClicked(3)">{{localService.languageContent.settings.generate_bill}}</button>
      </div>
    </div>
  </div>
  <br />
  <div>
    <label>{{localService.languageContent.settings.hdr_backup}}</label>
  </div>
  <div class="banner">
    <div class="row">
      <div class="col-sm-2">
        <button type="button" class="btn btn-secondary" (click)="onClicked(1)">{{localService.languageContent.settings.create_backup}}</button>
      </div>
      <div class="col-sm-3">
        <button type="button" class="btn btn-secondary en" (click)="onClicked(8)">Ensure Unique Keys</button>
      </div>
      <div class="col-sm-3">
        <button type="button" class="btn btn-secondary" (click)="onClicked(2)">{{localService.languageContent.settings.ensure_index}}</button>
      </div>
      <div class="col-sm-3">
        <button type="button" class="btn btn-secondary en" (click)="onClicked(7)">Fix Access Role For Page</button>
      </div>
    </div>
  </div>
  <br />
  <div>
    <label style="margin-left:15px;font-weight:normal;">
      <input type="radio" name="settings" [checked]="iSelectedTestCreation == 1" (click)="onChecked(1)">
      <span>&nbsp;{{localService.languageContent.settings.hdr_test_users}}</span>
    </label>
    &nbsp;
    <label style="margin-left:15px;font-weight:normal;">
      <input type="radio" name="settings" (click)="onChecked(2)">
      <span>&nbsp;{{localService.languageContent.settings.hdr_test_biz}}</span>
    </label>
    &nbsp;
    <label style="margin-left:15px;font-weight:normal;">
      <input type="radio" name="settings" (click)="onChecked(3)">
      <span>&nbsp;{{localService.languageContent.settings.hdr_test_product}}</span>
    </label>
    &nbsp;
    <button type="button" class="btn btn-secondary" (click)="onCreateTestData(4)">{{localService.languageContent.settings.create_deliverer}}</button>
  </div>
  <div class="banner" *ngIf="globalLocations != undefined && globalLocations != null">
    <div class="row">
      <div class="col-sm-10">
        <app-global-locations [countries]="globalLocations.countries" [states]="globalLocations.states" [selected]="globalLocations.selected"></app-global-locations>
      </div>
      <div class="col-sm-2">
        <div class="row">
          <div class="col-6">
            <input autocomplete="off" type="number" class="number" (keypress)="localService.isNumberOnly($event)" min="1" [(ngModel)]="iNumOfRecords" [ngClass]="iNumOfRecords != null ? 'en': ''" title="{{localService.languageContent.settings.num_of_records}}" placeholder="{{localService.languageContent.settings.num_of_records}}" />
          </div>
          <div class="col-6">
            <button type="button" class="btn btn-secondary" [disabled]="iNumOfRecords == null || iNumOfRecords == 0" (click)="onCreateJob()">{{localService.languageContent.common.submit}}</button>
          </div>
        </div>
      </div>
    </div>
  </div>
  <br />
  <div class="banner en">
    <div class="row">
      <div class="col-12">
        <textarea rows="6" [(ngModel)]="txtContent" placeholder="Enter your content here.."></textarea>
        <div>
          <label style="font-weight: normal; margin-left: 30px;">
            <input type="checkbox" [(ngModel)]="isIncludeLastPaging" />
            <span class="normal_color">Include Last Paging</span>
          </label>
          &nbsp;
          <label style="font-weight: normal; margin-left: 30px;">
            <input type="checkbox" [(ngModel)]="isIncludeSelected" />
            <span class="normal_color">Include Logged User Details</span>
          </label>
          &nbsp;
          <i class="material-icons icon_adjust" (click)="onClicked(5)">content_copy</i>
          &nbsp;
          <button type="button" class="btn btn-secondary" (click)="onClicked(4)">Check Content Length (Normal)</button>
          &nbsp;
          <button type="button" class="btn btn-secondary" (click)="onClicked(6)">Check Content Length (Raw Json)</button>
        </div>
      </div>
    </div>
  </div>
</div>
